/* eslint-disable import/prefer-default-export */
export const getCropZonesOnly = fieldsToMassiveAssign =>
  fieldsToMassiveAssign?.filter(field => field.cropzones.length > 0);
